import $ from 'jquery';
import { Subscription } from 'rxjs';

import {
  AfterViewInit,
  Component,
  ElementRef,
  HostBinding,
  Input,
  HostListener,
  ChangeDetectionStrategy,
  OnDestroy,
  OnInit,
} from '@angular/core';

import {
  Router,
  NavigationStart,
  RouterEvent,
} from '@angular/router';

import { Session } from '@services/session';
import { SidebarService, ISidebarState } from '@services/sidebar.service';
import { FleetGrowthFeatureFlagService } from '@services/feature-flags/growth';
import { PendoAnalytics } from '@services/pendo-analytics';

import { hasZuoraAccountNumber } from '@lib/boot-utils';
import { SUPPORT_FLEET, UPDATE_CREDIT_CARD } from '@lib/customer-support.const';
import { CircleQuestion } from 'phx-core';

@Component({
  selector: 'support-menu',
  templateUrl: './support-menu.component.html',
  styleUrls: ['./support-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SupportMenuComponent implements OnInit, AfterViewInit, OnDestroy {
  @HostBinding('class.collapse-sidebar') public isSideBarCollapsed: boolean;
  @HostBinding('class.light-theme') @Input() public isLightTheme: boolean;
  @HostBinding('class.placement-top-right') @Input() public placementTopRight: boolean;
  public isAppVersionSwitchingEnabled: boolean = true;
  public isDropdownOpen = false;
  public supportFleet: string = SUPPORT_FLEET;
  public updateCreditCardPageLink: string = UPDATE_CREDIT_CARD;
  public isChatbotEnabled: boolean;
  public isUpdateCreditCardEnabled: boolean;
  public isProductFeedbackEnabled: boolean;
  public readonly circleQuestion: string = CircleQuestion;
  public hasZuoraAccount: boolean;
  private $el: any;
  private routerSubscription: Subscription;
  private $dropdown;

  constructor(
    private el: ElementRef,
    private router: Router,
    private session: Session,
    private sidebarService: SidebarService,
    private pendo: PendoAnalytics,
    private fgFeatureFlagService: FleetGrowthFeatureFlagService,
  ) {
    this.$el = $(this.el.nativeElement);
    this.isChatbotEnabled = fgFeatureFlagService.isChatbotEnabled();
    this.isUpdateCreditCardEnabled = fgFeatureFlagService.isCreditCardFeatureFlagEnabled();
    this.isProductFeedbackEnabled = fgFeatureFlagService.isProductFeedbackMenuEnabled();
  }

  public ngOnInit() {
    this.sidebarService.stateListener.subscribe((state: ISidebarState) => {
      this.isSideBarCollapsed = state === 'collapsed';
    });

    this.hasZuoraAccount = hasZuoraAccountNumber(this.session.getCompany());
  }

  public ngAfterViewInit(): void {
    this.$dropdown = this.$el.find('.dropdown');
    this.routerSubscription = this.router.events
      .subscribe((e: RouterEvent) => { if (e instanceof NavigationStart) this.closeIfOpen(); })
    ;
  }

  public ngOnDestroy(): void {
    this.routerSubscription.unsubscribe();
  }

  public toggle(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
    const dropDownMenu: HTMLElement = document.querySelector('.user-account-settings-placeholder');
    if (dropDownMenu) {
      this.isDropdownOpen ?
      dropDownMenu.classList.add('bring-to-front') :
      dropDownMenu.classList.remove('bring-to-front');
    }
    this.$dropdown.transition('fade');
  }

  public loginAndRedirect(event: MouseEvent): void {
    this.pendo.loginAndRedirect(event.target as HTMLElement);
  }

  @HostListener('window:click', ['$event'])
  public onWindowClick(event: MouseEvent): void {
    const targetName = event.target['tagName'];
    const isIcon = targetName === 'svg' || targetName === 'path';

    // don't close the menu if clicked on icon (svg or path)
    if (!this.$el.has(event.target).length && !isIcon) this.closeIfOpen();
  }

  public closeIfOpen(): void {
    if (this.isDropdownOpen) this.toggle();
  }
}
